import React, {memo, useEffect, useState} from 'react';
import {ViewerToolbar} from './ViewerToolbar';
import './TextViewer.scss';
import {scrollToElementAndHighlight} from './ViewerUtils';

interface TextViewerProps {
    title: string;
    content: string;
}

export const TextViewer = memo(({title, content}: TextViewerProps) => {
    const [highlightedIndex, setHighlightedIndex] = useState<number>(0);
    const annotationIds: string[] = [];

    const addIdsToEmTags = (textWithEmTags: string, idClass: string) => {
        if (!textWithEmTags) {
            return '';
        }
        let index = 0;
        return textWithEmTags.replace(/(<em>)/g, () => {
            const highlightsId = 'hibu_' + idClass + '_hl_' + index++;
            annotationIds.push(highlightsId);
            return '<em id="' + highlightsId + '">';
        });
    };

    const titleWithEmTags = addIdsToEmTags(title, 'title');
    const contentWithEmTags = addIdsToEmTags(content, 'content');
    const annotationCount = annotationIds.length;

    const onHighlightIndexChange = (highlightIndex: number) => {
        setHighlightedIndex(highlightIndex);
        const element = document.getElementById(annotationIds[highlightIndex]);
        scrollToElementAndHighlight(element);
    };

    useEffect(() => {
        onHighlightIndexChange(0);
        //eslint-disable-next-line
    }, [title, content]);

    const onSearchTriggered = () => {
        setHighlightedIndex(0);
    };

    return (
        <div id={'hibuTextPreview'}>
            <ViewerToolbar
                highlightControl={{
                    onHighlightIndexChange: onHighlightIndexChange,
                    numHighlights: annotationCount,
                    highlightedIndex: highlightedIndex,
                }}
                onSearchTriggered={onSearchTriggered}
            />
            <div id={'hibuTextPreviewPageWrapper'}>
                <div id={'hibuTextPreviewPageScroll'}>
                    <div id={'hibuTextPreviewPage'}>
                        <h1 id={'textViewerTitle'} dangerouslySetInnerHTML={{__html: titleWithEmTags}}/>
                        <pre id={'textViewerContent'} dangerouslySetInnerHTML={{__html: contentWithEmTags}}/>
                    </div>
                </div>
            </div>
        </div>
    );
});
